import React from 'react';
import ReactDOM from 'react-dom';

export default function Portal(props: {
    container?: HTMLElement | null,
    children?: React.ReactNode,
    display?: boolean
}) {
    if (!props.container || props.display === false) {
        return null;
    }

    return ReactDOM.createPortal(props.children, props.container);
}
